export const ROUTER_URL = {
  Home: '/',
  // Auth
  UserProfile: '/me/profile',
  Auth: '/auth',
  Login: '/auth/login',
  // Item Management
  ItemManagement: '/item-management',
  ItemManagementImportDate: '/item-management/import-date',
  ItemManagementImportDateDetail: '/item-management/import-date/:id',
  ItemManagementQCDate: '/item-management/qc-date',
  ItemManagementDeliveredDate: '/item-management/delivered-date',
  ItemManagementViewLogs: '/item-management/:tab/view-logs',
  // Engineering Management
  EngineeringManagement: '/engineering-management',
  EngineeringManagementMajorProjects: '/engineering-management/major-projects',
  EngineeringManagementMajorProjectsDetail:
    '/engineering-management/major-projects/:id',
  EngineeringManagementSpecialProjects:
    '/engineering-management/special-projects',
  EngineeringManagementSpecialProjectsDetail:
    '/engineering-management/special-projects/:id',
  EngineeringManagementItemFault: '/engineering-management/items-fault',
  EngineeringManagementAddItemFault: '/engineering-management/items-fault/add',
  EngineeringManagementItemFaultsDetail:
    '/engineering-management/items-fault/:id',
  EngineeringManagementProductionFault:
    '/engineering-management/productions-fault',
  EngineeringManagementAddProductionFault:
    '/engineering-management/productions-fault/add',
  EngineeringManagementProductionFaultsDetail:
    '/engineering-management/productions-fault/:id',
  EngineeringManagementSummary: '/engineering-management/summary',
  EngineeringManagementViewLogs: '/engineering-management/:tab/view-logs',
  EngineeringManagementSpecialProjectUploadCost:
    '/engineering-management/special-projects/upload-cost',
  // User Management
  User: '/user',
  UserManagement: '/user/user-management',
  UserManagementOffice: '/user/user-management/office',
  UserManagementSubcontractor: '/user/user-management/subcontractor',
  UserManagementProduction: '/user/user-management/production',
  UserManagementEngineering: '/user/user-management/engineering',
  // Role Management
  RoleManagement: '/user/role-management',
  RoleManagementDetail: '/user/role-management/:id',
  RoleManagementAdd: '/user/role-management/add',
  RoleManagementEdit: '/user/role-management/edit/:id',
  // Engineering Team
  EngineeringTeam: '/user/engineering-team',
  // Subcontractor Management
  Subcontractor: '/subcontractor',
  SubcontractorAll: '/subcontractor/all',
  SubcontractorLaserCutting: '/subcontractor/laser-cutting',
  SubcontractorLaserCuttingDetail: '/subcontractor/laser-cutting/:id',
  SubcontractorInsulationCutting: '/subcontractor/insulation-cutting',
  SubcontractorInsulationCuttingDetail: '/subcontractor/insulation-cutting/:id',
  SubcontractorRollForming: '/subcontractor/roll-forming',
  SubcontractorRollFormingDetail: '/subcontractor/roll-forming/:id',
  SubcontractorFolding: '/subcontractor/folding',
  SubcontractorFoldingDetail: '/subcontractor/folding/:id',
  SubcontractorViewLogs: '/subcontractor/:tab/view-logs',
  // Special Project List
  SpecialProjectList: '/special-project-list',
  SpecialProjectDetail: '/special-project-list/:id',
  // Factory Management
  FactoryManagement: '/factory-management',
  FactoryManagementJobsDisplay: '/factory-management/jobs-display',
  FactoryManagementJobsSorting: '/factory-management/jobs-sorting',
  FactoryManagementViewLog: '/factory-management/view-log',
  // Company Management
  CompanyManagement: '/company-management',
  // Setting
  Settings: '/settings',
  EditSettings: '/settings/edit',
  // Rate Setting
  RateSetting: '/rate-setting',
  EditRateSettings: '/rate-setting/edit',
  EasterEgg: '/easter-egg',
};

export const USER_TAB_PATTERN = `${ROUTER_URL.UserManagement}/:tab`;
export const SUBCONTRACTOR_TAB_PATTERN = `${ROUTER_URL.Subcontractor}/:tab`;
export const SUBCONTRACTOR_TAB_DETAIL_PATTERN = `${ROUTER_URL.Subcontractor}/:tab/:id`;
export const SUBCONTRACTOR_DETAIL_PATTERN = '/subcontractor/{type}/{id}';
export const SUBCONTRACTOR_VIEW_LOGS_PATTERN = `${ROUTER_URL.Subcontractor}/:tab/view-logs`;
export const ENGINEERING_M_TAB_PATTERN = `${ROUTER_URL.EngineeringManagement}/:tab`;
export const ITEM_M_TAB_PATTERN = `${ROUTER_URL.ItemManagement}/:tab`;
export const ITEM_M_TAB_DETAIL_PATTERN = `${ROUTER_URL.ItemManagement}/:tab/:id`;
export const ITEM_M_VIEW_LOGS_PATTERN = `${ROUTER_URL.Subcontractor}/:tab/view-logs`;
export const FACTORY_MANAGEMENT_TAB_PATTERN = `${ROUTER_URL.FactoryManagement}/:tab`;
export const ENGINEERING_M_TAB_DETAIL_PATTERN = `${ROUTER_URL.EngineeringManagement}/:tab/:id`;
export const ENGINEERING_M_VIEW_LOGS_PATTERN = `${ROUTER_URL.EngineeringManagement}/:tab/view-logs`;
